import React, { memo, Fragment } from 'react';
import buildClassName from 'js/utils/classNameBuilder.util';
import { AccordionRow } from 'js/components/common/AccordionRow';

import { TABLE_VIEW } from '../../constants';
import { TableBodyRow } from '../TableBodyRow';
import { TableHeaderRow } from '../TableHeaderRow';

import style from './TableSummary.scss';

export const TableSummary = memo(({ data = [], summaryRowView, classNames }) => {
    return (
        <div className={buildClassName(['tableSummaryContainer'], style, classNames)}>
            {data.map(item => {
                const {
                    id,
                    isExpandedByDefault,
                    tableView: { headerCells: tableHeaderCells = [], rowCells: tableRowCells = [] } = {},
                    accordionView: {
                        headerCells: accHeaderCells = [],
                        rowCells: accRowCells = [],
                        tableViewHeaderCells = []
                    } = {}
                } = item;

                return summaryRowView === TABLE_VIEW.TABLE
                    ? (
                        <div key={id}>
                            <TableHeaderRow cells={tableHeaderCells} classNames={classNames} />
                            <TableBodyRow cells={tableRowCells} classNames={classNames} />
                        </div>
                    )
                    : (
                        <Fragment key={id}>
                            {Boolean(tableViewHeaderCells.length) && (
                                <TableHeaderRow cells={tableViewHeaderCells} classNames={classNames} />
                            )}
                            <AccordionRow
                                id={id}
                                key={id}
                                bodyCells={accRowCells}
                                headerCells={accHeaderCells}
                                isExpandedByDefault={isExpandedByDefault}
                                classNames={{
                                    ...classNames,
                                    ...tableViewHeaderCells.length && { accordionContainer: style.accordionContainer }
                                }}
                            />
                        </Fragment>
                    );
            })}
        </div>
    );
});
